import React from 'react';
import { FormGroup, ControlLabel } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';
import { reduxForm, Field, SubmissionError } from 'redux-form';
import resetPasswordValidator from '../../utils/resetPasswordValidator';
import SecurityBoxLogo from '../SecurityBoxLogo';
import SecurityBoxInput from '../SecurityBoxInput';
import ResetPasswordSecurityBoxControls from './ResetPasswordSecurityBoxControls';
import SecurityBoxCommonError from '../SecurityBoxCommonError';

import * as resetPassword from '../../action-creators/resetPassword';
import * as serviceActions from '../../action-creators/services';

const ResetPasswordContainer = translate(['ui'])(
  class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        recovery: false
      };
      this.onSubmit = this.onSubmit.bind(this);
    }

    onSubmit({ email }) {
      // eslint-disable-next-line no-shadow
      const { t, resetPassword, gaSend } = this.props;

      // Google Analytics
      gaSend({ category: 'Common', action: 'change_password_reg', label: email });

      return resetPassword(email)
        .then(res => {
          if (res.ok) {
            // alert(t('Message with a link to reset your password has been sent to your email address please check the mail'));
            return this.setState({ recovery: true });
          }
          return res.json();
        })
        .then(data => {
          if (data && data.error) {
            throw new SubmissionError({ _error: t(data.error) });
          }
        });
    }

    render() {
      const { t, error, handleSubmit } = this.props;
      const { recovery } = this.state;

      return (
        <div className="auth-box auth-box-register">
          <SecurityBoxLogo />
          <div className="small-form">
            {!recovery ? (
              <div>
                <ControlLabel
                  style={{ fontSize: 18, color: '#252b49', fontWeight: 'normal', marginTop: 61, marginLeft: 50 }}
                >
                  {t('Password recovery')}
                </ControlLabel>
                <FormGroup className="form-group-login" style={{ marginTop: 22 }}>
                  <ControlLabel className="control-label-login">{t('E-mail')}</ControlLabel>
                  <Field name="email" component={SecurityBoxInput} type="text" placeholder={t('Enter email')} />
                </FormGroup>
                <ResetPasswordSecurityBoxControls
                  linkText={t('Enter')}
                  submitText={t('Change password')}
                  submitAction={handleSubmit(this.onSubmit)}
                />

                <div style={{ marginTop: 20 }}>{error && <SecurityBoxCommonError error={t(error)} />}</div>
              </div>
            ) : (
              <div style={{ paddingTop: 64 }}>
                <p style={{ marginLeft: 183, fontSize: '18px', paddingBottom: 5 }}>
                  <img src="/img/ico_ok.svg" alt="" />
                </p>
                <p
                  style={{
                    textAlign: 'center',
                    width: 283,
                    fontSize: 14,
                    color: '#252b49',
                    marginLeft: 59,
                    marginTop: 24
                  }}
                >
                  {t('recovery_text')}
                </p>
                <p style={{ textAlign: 'center', width: 283, marginLeft: 59, marginTop: 30 }}>
                  <Link style={{ textDecoration: 'none', color: '#767b92', fontSize: 14, fontWeight: 500 }} to="/">
                    {t('to_main')}
                  </Link>
                </p>
              </div>
            )}
          </div>
        </div>
      );
    }
  }
);

const ResetPasswordForm = reduxForm({
  form: 'resetPassword',
  validate: resetPasswordValidator
})(ResetPasswordContainer);

export default connect(null, { ...resetPassword, ...serviceActions })(ResetPasswordForm);



// WEBPACK FOOTER //
// ./components/resetPassword/ResetPasswordContainer.jsx